import { render, staticRenderFns } from "./ShenzhenUnicomJd01.vue?vue&type=template&id=35d588e6&scoped=true"
import script from "./ShenzhenUnicomJd01.vue?vue&type=script&lang=js"
export * from "./ShenzhenUnicomJd01.vue?vue&type=script&lang=js"
import style0 from "./ShenzhenUnicomJd01.vue?vue&type=style&index=0&id=35d588e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d588e6",
  null
  
)

export default component.exports